import type { ApiResponse, Company, CompanyUpdatePayload } from "../types";
import { apiClient } from "./apiClient";

export interface CreateCompanyPayload {
  name: string;
}

export const companyApi = {
  async createCompany(
    payload: CreateCompanyPayload
  ): Promise<ApiResponse<Company>> {
    try {
      const data = await apiClient.post<any>(`/companies`, payload);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  /** GET /companies — lista de empresas do usuário (logos e dados atualizados). */
  async listCompanies(): Promise<ApiResponse<Company[]>> {
    try {
      const data = await apiClient.get<any>(`/companies`);
      const raw = data?.data ?? data;
      let list: Company[] = [];
      if (Array.isArray(raw)) {
        list = raw as Company[];
      } else if (raw && Array.isArray(raw.companies)) {
        list = raw.companies as Company[];
      } else if (raw && typeof raw === "object" && (raw as Company).id != null) {
        list = [raw as Company];
      }
      return {
        success: true,
        data: list,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Get company (current / default)
  async getCompany(): Promise<ApiResponse<Company>> {
    try {
      const data = await apiClient.get<any>(`/companies`);

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Get company by ID
  async getCompanyById(id: number): Promise<ApiResponse<Company>> {
    try {
      const data = await apiClient.get<any>(`/companies/${id}`);

      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Update an existing company (by id)
  async updateCompany(
    companyId: number,
    companyData: CompanyUpdatePayload
  ): Promise<ApiResponse<Company>> {
    try {
      const data = await apiClient.put<any>(`/companies/${companyId}`, companyData);

      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
